import type { FormsElementTypeEnum } from 'generated/resources/graphql'
export const FORMS_ELEMENT_TYPE = {
  Checkbox: 'checkbox',
  Date: 'date',
  DropdownMulti: 'dropdownmulti',
  DropdownSingle: 'dropdownsingle',
  File: 'file',
  LongText: 'longtext',
  MultiSelect: 'multiselect',
  Number: 'number',
  Rating: 'rating',
  Score: 'score',
  Section: 'section',
  Select: 'select',
  Text: 'text',
  Url: 'url',
} as const satisfies Record<string, FormsElementTypeEnum>
